<template>
  <list-view
    :with-sites="false"
    :sortable="false"
    color="primary"
    :items="groups"
    :create-item="'vk_group_create_edit'"
    :items-name="'name'"
    :edit-item="'vk_group_create_edit'"
    :title-field="'name'"
    @remove-item="updateData"
  ></list-view>
</template>

<script>
import ListView from '@/components/ListView'
export default {
  name: 'VKGroupsIndex',
  components: { ListView },
  data() {
    return {
      groups: [],
      limit: 20,
      page: 1,
    }
  },
  mounted() {
    this.updateData()
  },
  methods: {
    updateData() {
      this.albums = []
      this.axios({
        url: '/v1/integrations/vk/groups',
        method: 'get',
        params: { limit: this.limit, page: this.page },
      })
        .then((resp) => {
          this.groups = resp.data || []
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>
